import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { forkJoin, Observable } from "rxjs";
import { CommonService } from "../../../../app/services/common.service";
import { FileuploadService } from "../../../../app/services/fileupload.service";
import { BaseComponent } from "../../base.component";

@Component({
  selector: "app-vendor-registration",
  templateUrl: "./vendor-registration.component.html",
  styleUrls: ["./vendor-registration.component.css"],
})
export class VendorRegistrationComponent
  extends BaseComponent
  implements OnInit {
  myForm!: UntypedFormGroup;
  savedData: any = localStorage.getItem("");
  formData: FormData = new FormData();
  fileInput: any = "";
  file: File;
  currencyList: Array<any> = [];
  editData: any;
  isUrlBasedLogo: boolean = false;
  vendorCategoryList: Array<any> = [];
  vendorTypeList: Array<any> = [];
  dropdownVendorTypeSettings: any = {};
  selectedVendorType: { vendor_type_id: number; vendor_type_name: string }[];
  itemGroupList: Array<any> = [];
  dropdownItemGroupSettings: any = {};
  selectedItemGroup: { id: number; name: string }[];
  constructor(
    public formBuilder: UntypedFormBuilder,
    toastr: ToastrService,
    private route: Router,
    CommonService: CommonService,
    private fileuploadService: FileuploadService
  ) {
    super(CommonService, toastr);
    this.checkUrlLogo(location.href);
  }

  ngOnInit(): void {
    this.formInIt();
    this.loadData();
    this.loadAllDropdowns();
    this.dropdownVendorTypeSettings = {
      singleSelection: false,
      idField: "vendor_type_id",
      textField: "vendor_type_name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.dropdownItemGroupSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };
  }

  onSelectAll(event: any) { }
  onSelectOne(event: any) { }

  checkUrlLogo(url: string) {
    const urlObj = {
      dhanushFinance: "https://finance.dhanushinfotech.com/login",
      financeDemo: "https://financedemo.dhanushinfotech.com/login",
      nwhQa: "https://nwhfinanceqa.dhanushinfotech.com/login",
      nwhPreprod: "https://nwhfinancepreprod.dhanushinfotech.com/login",
      nwhProd: "https://finance.himscmchbhopal.com/login",
    };
    const { nwhQa, nwhPreprod, nwhProd, dhanushFinance, financeDemo } = urlObj;
    if (
      dhanushFinance === url ||
      financeDemo === url ||
      nwhQa === url ||
      nwhPreprod === url ||
      nwhProd === url
    ) {
      this.isUrlBasedLogo = true;
      localStorage.setItem("isUrlBasedLogo", "true");
    } else {
      this.isUrlBasedLogo = false;
      localStorage.setItem("isUrlBasedLogo", "false");
    }
  }

  formInIt() {
    this.myForm = this.formBuilder.group({
      organizationName: [
        { value: localStorage.getItem("Username"), disabled: true },
      ],
      emailId: [{ value: atob(localStorage.getItem("Email")), disabled: true }],
      mobileNo: [{ value: atob(localStorage.getItem("mNo")), disabled: true }],
      first_name: [""],
      last_name: [""],
      org_address: ["", Validators.required],
      vendor_code: [{ value: "", disabled: true }, Validators.required],
      org_reg_no: ["", Validators.required],
      kra_no: ["", Validators.required],
      upload_proof: ["", Validators.required],
      bank_name: ["", Validators.required],
      account_no: ["", Validators.required],
      branch: ["", Validators.required],
      vreg_currency_id: [3, Validators.required],
      vreg_vendor_type_id: ["", Validators.required],

      vreg_agpo_no: [""],
      vreg_group_ids: ["", Validators.required],
      vreg_ifmis_no: ["", Validators.required],
      vreg_con_emailId: ["", Validators.required],
      vreg_con_mobileNo: [
        "",
        [
          Validators.required,
          Validators.maxLength(12),
          Validators.pattern(/^[0-9]{12}$/),
        ],
      ],
      vreg_con_firstname: ["", Validators.required],
      vreg_con_lastname: ["", Validators.required],
    });
  }

  loadData() {
    this.CommonService.activateSpinner();
    this.CommonService.getCall(
      `FinanceVendor/GetVendorRegistrationById/${localStorage.TenantCode}/${localStorage.UserId}`
    ).subscribe(
      (res: any) => {
        console.log(res);
        if (res.data === null) {
          // this.loadParameters();
          const date = new Date();
          const formatted = `VED-${date.getFullYear()}${(date.getMonth() + 1)
            .toString()
            .padStart(2, "0")}${date
              .getDate()
              .toString()
              .padStart(2, "0")}-${Math.floor(Math.random() * 1000)}`;
          this.myForm.patchValue({
            vendor_code: formatted,
          });
        } else {
          this.editData = res.data;
          this.fileInput = this.editData?.vreg_document_path;
          this.myForm?.patchValue({
            organizationName: this.editData?.vreg_name,
            emailId: this.editData?.vreg_email,
            mobileNo: this.editData?.vreg_mobile,
            first_name: this.editData?.vreg_first_name,
            last_name: this.editData?.vreg_last_name,
            org_address: this.editData?.vreg_address,
            vendor_code: this.editData?.vreg_code,
            org_reg_no: this.editData?.vreg_Registration_no,
            kra_no: this.editData?.vreg_kra_no,
            // upload_proof: this.editData?.vreg_document_path,
            bank_name: this.editData?.vreg_bank_name,
            account_no: this.editData?.vreg_account_no,
            branch: this.editData?.vreg_branch,
            vreg_currency_id: this.editData?.vreg_currency_id,
            vreg_vendor_type_id: this.editData?.vreg_vendor_type_id,
            vreg_agpo_no: this.editData?.vreg_agpo_no,
            vreg_group_ids: this.editData?.vreg_group_ids,
            vreg_ifmis_no: this.editData?.vreg_ifmis_no,
            vreg_con_emailId: this.editData?.vreg_con_emailId,
            vreg_con_mobileNo: this.editData?.vreg_con_mobileNo,
            vreg_con_firstname: this.editData?.vreg_con_firstname,
            vreg_con_lastname: this.editData?.vreg_con_lastname,
          });
          console.log("Group IDs from API:", this.editData?.vreg_group_ids);
        }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      }
    );
  }

  loadParameters() {
    this.CommonService.activateSpinner();
    this.CommonService.getCall(
      `Parameter/GetList/${localStorage.TenantCode}/${11}`
    ).subscribe(
      (res: any) => {
        let sequence_id = res.data.find(
          (e: any) => e.par_parametername_id == 16
        )?.par_squence_id;
        if (sequence_id == undefined) {
          this.toastr.warning("Vendor Code is not assigned");
        } else {
          this.bindPurchaseOrder(sequence_id);
        }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      }
    );
  }

  loadAllDropdowns() {
    this.CommonService.activateSpinner();
    const tntCode = +localStorage.TenantCode;
    // const currencyPayload = { DictionaryCode: '465154cd' };
    // const currency$ = this.CommonService.postCall('DataDictionary/GetDictionaryByKey', currencyPayload);
    const currency$ = this.CommonService.getCall(
      `Currency/GetList/${tntCode}/1`
    );
    const vendorCategories$ = this.CommonService.getCall(
      `FinanceVendor/VendorcategoryGetByActive/${tntCode}/1`
    );
    const vendorType$ = this.CommonService.getCall(
      `BidTenderCreation/GetVendorTypeList/${tntCode}`
    );
    const itemGroup$ = this.CommonService.getCall(
      `PurchaseOrders/GetProcurementItemGroups/${tntCode}/true`
    );
    forkJoin([currency$, vendorCategories$, vendorType$, itemGroup$]).subscribe(
      ([
        currencyRes,
        vendorCategoryRes,
        vendorTypeRes,
        itemGroupRes,
      ]: any[]) => {
        this.currencyList = currencyRes.data;
        this.vendorCategoryList = vendorCategoryRes.data;
        this.vendorTypeList = vendorTypeRes.data;
        this.vendorTypeList = vendorTypeRes.data;
        this.itemGroupList = itemGroupRes.data.map((e) => ({
          ...e,
          id: e.itemgroup_id,
          name: `${e.ig_itemgroup} - ${e.ig_name}`,
        }));

        this.CommonService.deactivateSpinner();
      },
      (error) => {
        console.error("Error loading dropdowns:", error);
        this.CommonService.deactivateSpinner();
      }
    );
  }

  bindPurchaseOrder(sId: any) {
    this.CommonService.activateSpinner();
    this.CommonService.getCall(
      `SequenceNumber/GetSequenceNumber/${localStorage.TenantCode}/${sId}`
    ).subscribe(
      (res: any) => {
        if (res.data.length) {
          this.myForm.patchValue({ vendor_code: res.data[0].seqnumber });
        } else {
          this.toastr.info("Vendor Code is not genarted", "Please try again");
        }
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.CommonService.deactivateSpinner();
      }
    );
  }

  onFileChange(event: any) {
    this.CommonService.activateSpinner();
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      if (this.file.type !== "application/pdf") {
        this.toastr.warning("Only PDF files are allowed!");
        event.target.value = "";
        this.CommonService.deactivateSpinner();
        return;
      }
      // this.myForm.patchValue({ upload_proof: this.file.name })
    }
    this.CommonService.deactivateSpinner();
  }

  private createFormData(): FormData {
    let data = this.myForm.getRawValue();
    const formData = new FormData();
    formData.append("vreg_name", data.organizationName);
    formData.append("vreg_email", data.emailId);
    formData.append("vreg_mobile", data.mobileNo);
    formData.append("vreg_first_name", data.vreg_con_firstname);
    formData.append("vreg_last_name", data.vreg_con_lastname);
    formData.append("vreg_address", data.org_address);
    formData.append("vreg_code", data.vendor_code);
    formData.append("vreg_Registration_no", data.org_reg_no);
    formData.append("vreg_kra_no", data.kra_no);
    formData.append("vreg_document_path", this.file);
    formData.append("vreg_bank_name", data.bank_name);
    formData.append("vreg_account_no", data.account_no);
    formData.append("vreg_branch", data.branch);
    formData.append("status", "false");
    formData.append("created_by", localStorage.UserId);
    formData.append("tnt_code", localStorage.TenantCode);
    formData.append("modified_by", localStorage.UserId);
    formData.append("vreg_user_id", localStorage.UserId);
    formData.append("vreg_currency_id", data.vreg_currency_id);
    formData.append(
      "vreg_vendor_type_id",
      this.selectedVendorType?.map((i: any) => i.vendor_type_id).join(",") || ""
    );

    formData.append("vreg_agpo_no", data.vreg_agpo_no);
    formData.append(
      "vreg_group_ids",
      this.selectedItemGroup?.map((e: any) => e.id).join(",") || ""
    );
    formData.append("vreg_ifmis_no", data.vreg_ifmis_no);
    formData.append("vreg_con_emailId", data.vreg_con_emailId);
    formData.append("vreg_con_mobileNo", data.vreg_con_mobileNo);
    formData.append("vreg_con_firstname", data.vreg_con_firstname);
    formData.append("vreg_con_lastname", data.vreg_con_lastname);
    formData.append("created_by", this.userId);
    formData.append("tnt_code", this.TenantCode);
    formData.append("modified_by", this.userId);
    formData.append("vreg_user_id", this.userId);
    formData.append(
      "url",
      location.origin.includes("localhost")
        ? "https://oukdev.samvaadpro.com/vendorlogin"
        : location.origin + "/vendorlogin"
    );
    // formData.append('registration_id', this.editData?.registration_id || 0);
    return formData;
  }

  submit(form: any) {
    this.activeSpinner();
    const formData = this.createFormData();
    console.log(formData);
    this.fileuploadService
      // .upload(formData, "FinanceVendor/VendorRegistration")
      .upload(formData, "FinanceVendor/NewVendorRegistration")
      .subscribe(
        (res) => {
          if (res.status === true) {
            this.toastr.success("Registration Created successfully");
            this.file = null;
            // this.route.navigate(['/OneApp'])
            this.close();
          } else if (res.status === false) {
            this.toastr.warning(res.message);
          }
          this.deactivateSpinner();
        },
        (error) => {
          if (error.status === 400) {
            this.toastr.error(error.error);
          } else {
            this.toastr.error("An unexpected error occurred.");
          }
          this.deactivateSpinner();
        }
      );
  }

  close() {
    this.clearToken();
    setTimeout(() => {
      localStorage.clear();
      sessionStorage.clear();
      this.route.navigate(["/vendorlogin"]);
    }, 500);
  }
  clearToken() {
    this.CommonService.postCall("Account/ClearToken", {
      UserID: localStorage.getItem("UserId"),
    }).subscribe((res: any) => { });
  }

  viewFile() {
    if (this.fileInput == "") {
      this.toastr.warning("File not available");
    } else {
      window.open(this.CommonService.videoUrl + this.fileInput);
    }
  }

  removeFile(typ: any) {
    this.file = null;
    this.myForm.patchValue({
      upload_proof: "",
    });
    this.fileInput = "";
  }
}
